import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import CeremonyForm from "./CeremonyForm";
import ConservationCare from "./ConservationCareForm";
import OtherProvision from "./OtherProvisionForm";
import {
    starSetCeremony,
    starSetConservationCare,
    starSetOtherProvision,
    starGetMesObsequesData,
    starSetMesObsequesData
} from "../../actions/funeral";
import Loader from '../Loader';
import { deleteFile } from '../../api/api';
import { pushToDataLayer } from '../../utils/gtmUtils';

class FuneralPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
            promiseIsResolved: false,
            tabs: [
                {
                    id: 0,
                    name: 'Cérémonie'
                },
                {
                    id: 1,
                    name: 'Soins de conservation'
                },
                {
                    id: 2,
                    name: 'Autres dispositions'
                },

            ],
            ceremonie: [],
            typeSoinConservation: '',
            spinner: 'inactive',
            autres: []
        }
    }

    componentWillMount = () => {
        this.props.starGetMesObsequesData(this.props.beneficiaryData.idBeneficiaire, this.props.partenaireData.id).then((response) => {
            this.setState({
                ceremonie: response.data.ceremonie,
                typeSoinConservation: response.data.typeSoinConservation,
                autres: response.data.autres,
                promiseIsResolved: true,
                dataCharged : response.data
            });
            if (response.data.ceremonie != null) this.props.starSetCeremony(response.data.ceremonie);
            if (response.data.typeSoinConservation != null) this.props.starSetConservationCare(response.data.typeSoinConservation);
            if (response.data.autres != null) this.props.starSetOtherProvision(response.data.autres);
        }).catch((error) => {
            console.log('error', error);
        });
    }

    selectTab = (selected) => {
        this.setState({ selected });
    }



    goBack = (e) => {
        e.preventDefault();
        if (this.state.selected === 0) {
            this.props.history.push('/accueil');
        } else {
            this.selectTab(this.state.selected - 1);
        }
    }

    onCeremonySubmit = (ceremonyData) => {
        //console.log('ceremonyData', ceremonyData);
        this.props.starSetCeremony(ceremonyData);
        this.setState(() => ({ selected: 1, ceremonie: ceremonyData }));
    };
    onConservationCareSubmit = (conservationCareData) => {
        //console.log('conservationCareData', conservationCareData);
        this.props.starSetConservationCare(conservationCareData);
        this.setState(() => ({ selected: 2, typeSoinConservation: conservationCareData }));
    }
    onOtherProvisionSubmit = (otherProvisionData) => {
        const dataLayer = {
            event: "funeralSave",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);
          
        this.setState({ spinner: 'active' })
        this.props.starSetOtherProvision(otherProvisionData);
        this.setState(() => ({ autres: otherProvisionData }));
        // commit information
        let postObject = {
            idBeneficiaire: this.props.beneficiaryData.idBeneficiaire,
            ceremonie: this.state.ceremonie,
            typeSoinConservation: this.state.typeSoinConservation,
            autres: otherProvisionData
        }
        const self = this;
        this.props.starSetMesObsequesData(postObject, this.props.partenaireData.id).then(response => {
            if (postObject.ceremonie.file) {
                const dataLayer = {
                    event: "requestSend",
                    url: window.location.href,
                    fileType: "ceremonyText",
                    idPartenaire: this.props.partenaireData.id
                }
                pushToDataLayer(dataLayer);
            }
            if ( postObject.autres.file) {
                const dataLayer = {
                    event: "requestSend",
                    url: window.location.href,
                    fileType: "ceremonyVideo",
                    idPartenaire: this.props.partenaireData.id
                }
                pushToDataLayer(dataLayer);
            }
            self.props.history.push('/accueil');
            this.setState({ spinner: 'inactive' })
        }).catch(function (error) {
            console.log('error', error);
        });
    }

    deleteFile = (data) => {
        deleteFile(data, this.props.partenaireData.id).then(data => {
            console.log("File deleted " + data.data);
        }, error => {
            // handle errors
        });
    }

    render() {
        if (!this.state.promiseIsResolved) { return null }
        return (
            <div className="memory-page container main-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Mes obsèques</li>
                </ol>
                <h1 className="text-center">Mes obsèques</h1>
                <div className="intro-text">
                    Pour que vos proches sachent ce que vous souhaitez pour vos funérailles, indiquez dès maintenant ce que vous voulez
                	pour la cérémonie et pour les soins de conservations.
                </div>

                <ul className="tab-list">
                    {
                        this.state.tabs.map((tab, i) =>
                            <li
                                key={i}
                                className={this.state.selected === tab.id ? 'tab-item active' : 'tab-item'}
                            >{tab.name}
                            </li>
                        )
                    }
                </ul>
                {this.state.dataCharged ?
                    <div>
                        {this.state.selected === 0 &&
                            <CeremonyForm
                                onCeremonySubmit={this.onCeremonySubmit}
                                data={this.state.ceremonie}
                                idBeneficiaire = { this.props.beneficiaryData && this.props.beneficiaryData.idBeneficiaire}
                                back={this.goBack}
                                countryData={this.props.countryData} 
                                deleteFile = {this.deleteFile}
                                idPartenaire = {this.props.partenaireData.id}/>
                        }
                        {this.state.selected === 1 &&
                            <ConservationCare
                                onConservationCareSubmit={this.onConservationCareSubmit}
                                data={this.state.typeSoinConservation}
                                back={this.goBack} />
                        }
                        {this.state.selected === 2 &&
                            <OtherProvision
                                onOtherProvisionSubmit={this.onOtherProvisionSubmit}
                                data={this.state.autres}
                                back={this.goBack} 
                                idBeneficiaire = { this.props.beneficiaryData && this.props.beneficiaryData.idBeneficiaire}
                                spinner={this.state.spinner} 
                                deleteFile = {this.deleteFile}
                                idPartenaire = {this.props.partenaireData.id} />
                        }

                    </div> 
                    :
                    <Loader />
                }
            </div>
        )
    }

}


const mapDispatchToProps = (dispatch) => {
    return {
        starSetCeremony: (ceremonyData) => dispatch(starSetCeremony(ceremonyData)),
        starSetConservationCare: (conservationCareData) => dispatch(starSetConservationCare(conservationCareData)),
        starSetOtherProvision: (otherProvisionData) => dispatch(starSetOtherProvision(otherProvisionData)),
        starGetMesObsequesData: (idBeneficiaire, idPartenaire) => dispatch(starGetMesObsequesData(idBeneficiaire, idPartenaire)),
        starSetMesObsequesData: (mesObsequesData, idPartenaire) => dispatch(starSetMesObsequesData(mesObsequesData, idPartenaire))
    }
};

const mapStateToProps = state => {
    return {
        mesObsequesData: state.mesObsequesData,
        beneficiaryData: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData : JSON.parse(sessionStorage.getItem('benef')),
        countryData: state.countryData,
        partenaireData: state.partenaireData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FuneralPage);





// WEBPACK FOOTER //
// ./src/components/FuneralPage/FuneralPage.js